// Page-section (block) editor messages. Prefix `blocks.`; English is the source of truth.
export const blocksEn = {
  'blocks.meta.hero.label': 'Hero',
  'blocks.meta.hero.description': 'Full-bleed image with headline and buttons',
  'blocks.meta.split.label': 'Text + image',
  'blocks.meta.split.description': 'Two columns: copy beside an image',
  'blocks.meta.stats.label': 'Stats',
  'blocks.meta.stats.description': 'Row of big numbers',
  'blocks.meta.cardGrid.label': 'Card grid',
  'blocks.meta.cardGrid.description': 'Grid of linked cards',
  'blocks.meta.content.label': 'Rich text',
  'blocks.meta.content.description': 'Long-form formatted content',
  'blocks.meta.faq.label': 'FAQ',
  'blocks.meta.faq.description': 'Questions and answers',
  'blocks.meta.quotes.label': 'Testimonials',
  'blocks.meta.quotes.description': 'Client quotes with name and organisation',
  'blocks.meta.imageGrid.label': 'Image grid',
  'blocks.meta.imageGrid.description': 'Logos, portfolio or photo wall',
  'blocks.meta.catalogue.label': 'Catalogue list',
  'blocks.meta.catalogue.description': 'Live industries, categories or every product',
  'blocks.meta.portfolio.label': 'Portfolio',
  'blocks.meta.portfolio.description': 'Filterable gallery of projects',
  'blocks.meta.spotlight.label': 'Spotlight',
  'blocks.meta.spotlight.description': 'Large image with a numbered feature list',
  'blocks.meta.columns.label': 'Text columns',
  'blocks.meta.columns.description': 'Heading beside running copy, figures and a link',
  'blocks.meta.team.label': 'Team',
  'blocks.meta.team.description': 'People cards and role grids',
  'blocks.meta.showcase.label': 'Project showcase',
  'blocks.meta.showcase.description': 'One concept-work project with photos',
  'blocks.meta.strip.label': 'Image band',
  'blocks.meta.strip.description': 'Full-width picture strip',
  'blocks.meta.swatches.label': 'Swatch library',
  'blocks.meta.swatches.description': 'All materials or finishes, grouped, from the library',
  'blocks.meta.guide.label': 'Guide',
  'blocks.meta.guide.description': 'Copy beside a ruled list of titled answers',
  'blocks.meta.booking.label': 'Booking calendar',
  'blocks.meta.booking.description': 'Embed Cal.com, Calendly or a Google appointment page',
  'blocks.f.bookingUrl': 'Booking page link',
  'blocks.hint.bookingUrl': 'An https link from Cal.com, Calendly, Google Calendar appointments, TidyCal, SavvyCal, Setmore, YouCanBookMe or Zcal.',
  'blocks.f.bookingHeight': 'Calendar height',
  'blocks.f.bookingLinkLabel': 'Fallback link text',
  'blocks.hint.bookingLinkLabel': 'Shown under the calendar as a plain link. Leave empty for the default.',
  'blocks.err.bookingUrl': 'Use an https link from a supported booking tool',
  'blocks.meta.cta.label': 'Call to action',
  'blocks.meta.cta.description': 'Dark section or band with buttons',
  'blocks.panel.title': 'Page Sections',
  'blocks.panel.description': 'Sections render top to bottom in this order.',
  'blocks.panel.empty': 'No sections yet. Add a hero to start.',
  'blocks.addSection': 'Add section',
  'blocks.add': '+ Add',
  'blocks.moveUp': 'Move up',
  'blocks.moveDown': 'Move down',
  'blocks.removeSection': 'Remove section',
  'blocks.hint.accent': 'Wrap words in *asterisks* for the italic accent.',
  'blocks.hint.paragraphs': 'Separate paragraphs with a blank line.',
  'blocks.hint.anchor': 'Optional. Link straight to this section with #anchor, e.g. /about#equipment.',
  'blocks.hint.youtube': 'A video link or id. Only YouTube is supported.',
  'blocks.hint.itemTitle': '{title} is replaced with the item name.',
  'blocks.hint.productCount': '{count} is replaced with the number of products.',
  'blocks.hint.count': '{count} is replaced.',
  'blocks.note.catalogue': 'Items come from published catalogue content and follow its order.',
  'blocks.note.swatches': 'Items come from Materials & Finishes. A swatch sits under the group whose key matches its “Group key”; swatches with no matching group are left out.',
  'blocks.f.label': 'Label',
  'blocks.f.link': 'Link',
  'blocks.f.linkOptional': 'Link (optional)',
  'blocks.f.eyebrow': 'Eyebrow',
  'blocks.f.heading': 'Heading',
  'blocks.f.headline': 'Headline',
  'blocks.f.body': 'Body',
  'blocks.f.content': 'Content',
  'blocks.f.intro': 'Intro',
  'blocks.f.image': 'Image',
  'blocks.f.backgroundImage': 'Background image',
  'blocks.f.photo': 'Photo',
  'blocks.f.photos': 'Photos',
  'blocks.f.background': 'Background',
  'blocks.f.layout': 'Layout',
  'blocks.f.style': 'Style',
  'blocks.f.columns': 'Columns',
  'blocks.f.value': 'Value',
  'blocks.f.title': 'Title',
  'blocks.f.key': 'Key',
  'blocks.f.name': 'Name',
  'blocks.f.role': 'Role',
  'blocks.f.badge': 'Badge',
  'blocks.f.bio': 'Bio',
  'blocks.f.tagline': 'Tagline',
  'blocks.f.caption': 'Caption',
  'blocks.f.quote': 'Quote',
  'blocks.f.nameOrRole': 'Name or role',
  'blocks.f.organisation': 'Organisation',
  'blocks.f.answer': 'Answer',
  'blocks.f.anchor': 'Anchor',
  'blocks.f.youtube': 'YouTube video',
  'blocks.f.imageSide': 'Image side',
  'blocks.f.imageStyle': 'Image style',
  'blocks.f.statsUnderText': 'Stats under the text (optional)',
  'blocks.f.sideImage': 'Side image (optional)',
  'blocks.f.cardLinkText': 'Card link text',
  'blocks.f.listHeading': 'List heading',
  'blocks.f.exclusionsHeading': 'Exclusions heading',
  'blocks.f.numberCards': 'Number the cards (01, 02, …)',
  'blocks.f.headerLinkLabel': 'Header link label',
  'blocks.f.headerLink': 'Header link',
  'blocks.f.labelAboveTitle': 'Label (above the title)',
  'blocks.f.issuerUnderTitle': 'Issuer (under the title)',
  'blocks.f.list': 'List',
  'blocks.f.notIncluded': 'Not included',
  'blocks.f.legalTitle': 'Document title (H1)',
  'blocks.f.primaryLabel': 'Primary label',
  'blocks.f.secondaryLabel': 'Secondary label',
  'blocks.f.buttons': 'Buttons',
  'blocks.f.lists': 'Lists',
  'blocks.f.itemLinkText': 'Item link text',
  'blocks.f.productCount': 'Product count',
  'blocks.f.extraGroupHeading': 'Extra group heading',
  'blocks.f.allTabLabel': '“All” tab label',
  'blocks.f.countLabel': 'Count label',
  'blocks.f.filterTabs': 'Filter tabs',
  'blocks.f.tabLabel': 'Tab label',
  'blocks.f.project': 'Project',
  'blocks.f.client': 'Client',
  'blocks.f.finishes': 'Finishes',
  'blocks.f.filter': 'Filter',
  'blocks.f.wide': 'Wide',
  'blocks.f.groupN': 'Group {n} label',
  'blocks.f.sideEyebrow': 'Side eyebrow',
  'blocks.f.sideTitle': 'Side title',
  'blocks.f.numberedPoints': 'Numbered points',
  'blocks.f.figures': 'Figures (label and value rows)',
  'blocks.f.linkLabel': 'Link label',
  'blocks.f.buttonLabel': 'Button label',
  'blocks.f.buttonLink': 'Button link',
  'blocks.f.responsibilities': 'Responsibilities',
  'blocks.f.clientLabel': 'Label (client)',
  'blocks.f.clientQuote': 'Client quote',
  'blocks.f.tags': 'Tags',
  'blocks.f.credit': 'Credit line',
  'blocks.f.stripImage': 'Image (shown as a 120px full-width band)',
  'blocks.f.shows': 'Shows',
  'blocks.f.jumpLinks': 'Jump-link row with counts above the groups',
  'blocks.f.groupsInOrder': 'Groups, in order',
  'blocks.f.titledAnswers': 'Titled answers',
  'blocks.add.link': '+ Link',
  'blocks.add.button': '+ Button',
  'blocks.add.stat': '+ Stat',
  'blocks.add.card': '+ Card',
  'blocks.add.quote': '+ Quote',
  'blocks.add.image': '+ Image',
  'blocks.add.headerLink': '+ Header link',
  'blocks.add.filter': '+ Filter',
  'blocks.add.project': '+ Project',
  'blocks.add.item': '+ Item',
  'blocks.add.exclusion': '+ Exclusion',
  'blocks.add.row': '+ Row',
  'blocks.add.point': '+ Point',
  'blocks.add.person': '+ Person',
  'blocks.add.role': '+ Role',
  'blocks.add.group': '+ Group',
  'blocks.add.tag': '+ Tag',
  'blocks.add.answer': '+ Answer',
  'blocks.remove': 'Remove',
  'blocks.removeGroup': 'Remove group',
  'blocks.removePerson': 'Remove person',
  'blocks.ph.exploreSector': 'Explore sector',
  'blocks.ph.youReceive': 'You receive',
  'blocks.ph.exploreTitle': 'Explore {title}',
  'blocks.ph.countTypes': '{count} types',
  'blocks.ph.specification': 'Specification',
  'blocks.ph.countWorks': '{count} works',
  'blocks.ph.officeBadge': 'Australia Office',
  'blocks.ph.designBy': 'Design by …',
  'blocks.opt.ivory': 'Ivory',
  'blocks.opt.linen': 'Linen',
  'blocks.opt.bone': 'Bone',
  'blocks.opt.ink': 'Ink (dark)',
  'blocks.opt.right': 'Right',
  'blocks.opt.left': 'Left',
  'blocks.opt.materials': 'Materials',
  'blocks.opt.edgeToEdge': 'Edge to edge',
  'blocks.opt.insetCard': 'Inset card (rounded, shadow)',
  'blocks.opt.hero.fullBleed': 'Full-bleed image',
  'blocks.opt.hero.split': 'Copy beside a rounded image',
  'blocks.opt.hero.text': 'Compact page intro',
  'blocks.opt.hero.statement': 'Large statement intro',
  'blocks.opt.hero.video': 'Copy beside a YouTube video',
  'blocks.opt.hero.centered': 'Small centered intro',
  'blocks.opt.grid.grid': 'Grid of image cards',
  'blocks.opt.grid.carousel': 'Carousel (scrolls sideways)',
  'blocks.opt.grid.bordered': 'Ruled cells with a link',
  'blocks.opt.grid.aside': 'Intro + image beside text cards',
  'blocks.opt.grid.numbered': 'Numbered photo cards',
  'blocks.opt.grid.certificates': 'Framed documents (certificates)',
  'blocks.opt.grid.facts': 'Facts (label, title, text)',
  'blocks.opt.grid.gallery': 'Contained photos with titles',
  'blocks.opt.grid.levels': 'Ruled columns with a list',
  'blocks.opt.grid.definitions': 'Term / definition grid',
  'blocks.opt.content.prose': 'Editorial long-form',
  'blocks.opt.content.legal': 'Legal document (plain type, own H1)',
  'blocks.opt.faq.list': 'Single column',
  'blocks.opt.faq.columns': 'Two columns on a tinted band',
  'blocks.opt.imageGrid.tiles': 'Square photo tiles',
  'blocks.opt.imageGrid.logos': 'Logo strip',
  'blocks.opt.catalogue.industries': 'Industries (link cells)',
  'blocks.opt.catalogue.families': 'Product categories (cards)',
  'blocks.opt.catalogue.index': 'Every product, by category',
  'blocks.opt.cta.centered': 'Centered section',
  'blocks.opt.cta.band': 'Single-row band',
  'blocks.opt.cta.left': 'Left-aligned dark section',
  'blocks.opt.columns.ruled': 'Ruled row (heading left, copy right)',
  'blocks.opt.columns.callout': 'Callout (7/5 split under a rule)',
  'blocks.opt.columns.centered': 'Centered heading, narrow copy',
  'blocks.meta.game.label': 'Game',
  'blocks.meta.game.description': 'A game panel with a phone, store buttons and screenshots',
  'blocks.f.gameTag': 'Tag',
  'blocks.ph.gameTag': 'Coming soon',
  'blocks.f.gameTitle': 'Game name',
  'blocks.f.phoneImage': 'Game on the phone (landscape)',
  'blocks.f.mascot': 'Character (optional, cut-out PNG or WebP)',
  'blocks.f.googlePlay': 'Google Play',
  'blocks.f.appStore': 'App Store',
  'blocks.f.storeUrl': 'Store link',
  'blocks.hint.googlePlay': 'An https://play.google.com/… link.',
  'blocks.hint.appStore': 'An https://apps.apple.com/… link.',
  'blocks.err.googlePlay': 'Use an https://play.google.com/… link',
  'blocks.err.appStore': 'Use an https://apps.apple.com/… link',
  'blocks.opt.store.off': 'Not shown',
  'blocks.opt.store.soon': 'Coming soon (no link)',
  'blocks.opt.store.live': 'Live: link to the store',
  'blocks.f.gameButton': 'Button (optional)',
  'blocks.f.gameMore': '"Learn more" button (optional)',
  'blocks.hint.gameMore': "The game's own page or site. The game name and the phone picture link there too.",
  'blocks.f.screenshots': 'Screenshots (up to 4, landscape)',
  'blocks.add.screenshot': '+ Screenshot',
  'blocks.opt.cta.form': 'Text beside the contact form',
} as const

export const blocksId: Record<keyof typeof blocksEn, string> = {
  'blocks.meta.hero.label': 'Hero',
  'blocks.meta.hero.description': 'Gambar selebar penuh dengan judul dan tombol',
  'blocks.meta.split.label': 'Teks + gambar',
  'blocks.meta.split.description': 'Dua kolom: teks di samping gambar',
  'blocks.meta.stats.label': 'Statistik',
  'blocks.meta.stats.description': 'Deretan angka besar',
  'blocks.meta.cardGrid.label': 'Grid kartu',
  'blocks.meta.cardGrid.description': 'Grid kartu bertaut',
  'blocks.meta.content.label': 'Teks berformat',
  'blocks.meta.content.description': 'Konten panjang berformat',
  'blocks.meta.faq.label': 'FAQ',
  'blocks.meta.faq.description': 'Pertanyaan dan jawaban',
  'blocks.meta.quotes.label': 'Testimoni',
  'blocks.meta.quotes.description': 'Kutipan klien dengan nama dan organisasi',
  'blocks.meta.imageGrid.label': 'Grid gambar',
  'blocks.meta.imageGrid.description': 'Logo, portofolio, atau dinding foto',
  'blocks.meta.catalogue.label': 'Daftar katalog',
  'blocks.meta.catalogue.description': 'Industri, kategori, atau semua produk secara langsung',
  'blocks.meta.portfolio.label': 'Portofolio',
  'blocks.meta.portfolio.description': 'Galeri proyek yang bisa difilter',
  'blocks.meta.spotlight.label': 'Sorotan',
  'blocks.meta.spotlight.description': 'Gambar besar dengan daftar keunggulan bernomor',
  'blocks.meta.columns.label': 'Kolom teks',
  'blocks.meta.columns.description': 'Judul di samping teks, angka, dan tautan',
  'blocks.meta.team.label': 'Tim',
  'blocks.meta.team.description': 'Kartu orang dan grid jabatan',
  'blocks.meta.showcase.label': 'Etalase proyek',
  'blocks.meta.showcase.description': 'Satu proyek konsep beserta foto',
  'blocks.meta.strip.label': 'Pita gambar',
  'blocks.meta.strip.description': 'Strip gambar selebar penuh',
  'blocks.meta.swatches.label': 'Pustaka sampel',
  'blocks.meta.swatches.description': 'Semua bahan atau finishing dari pustaka, dikelompokkan',
  'blocks.meta.guide.label': 'Panduan',
  'blocks.meta.guide.description': 'Teks di samping daftar jawaban berjudul yang bergaris',
  'blocks.meta.booking.label': 'Kalender pemesanan',
  'blocks.meta.booking.description': 'Sematkan Cal.com, Calendly, atau halaman janji temu Google',
  'blocks.f.bookingUrl': 'Tautan halaman pemesanan',
  'blocks.hint.bookingUrl': 'Tautan https dari Cal.com, Calendly, janji temu Google Calendar, TidyCal, SavvyCal, Setmore, YouCanBookMe, atau Zcal.',
  'blocks.f.bookingHeight': 'Tinggi kalender',
  'blocks.f.bookingLinkLabel': 'Teks tautan cadangan',
  'blocks.hint.bookingLinkLabel': 'Ditampilkan di bawah kalender sebagai tautan biasa. Kosongkan untuk teks bawaan.',
  'blocks.err.bookingUrl': 'Gunakan tautan https dari alat pemesanan yang didukung',
  'blocks.meta.cta.label': 'Ajakan bertindak (CTA)',
  'blocks.meta.cta.description': 'Bagian atau pita gelap dengan tombol',
  'blocks.panel.title': 'Bagian Halaman',
  'blocks.panel.description': 'Bagian ditampilkan dari atas ke bawah sesuai urutan ini.',
  'blocks.panel.empty': 'Belum ada bagian. Tambahkan hero untuk memulai.',
  'blocks.addSection': 'Tambah bagian',
  'blocks.add': '+ Tambah',
  'blocks.moveUp': 'Naikkan',
  'blocks.moveDown': 'Turunkan',
  'blocks.removeSection': 'Hapus bagian',
  'blocks.hint.accent': 'Apit kata dengan *tanda bintang* untuk aksen miring.',
  'blocks.hint.paragraphs': 'Pisahkan paragraf dengan satu baris kosong.',
  'blocks.hint.anchor': 'Opsional. Tautkan langsung ke bagian ini dengan #anchor, mis. /about#equipment.',
  'blocks.hint.youtube': 'Tautan atau ID video. Hanya YouTube yang didukung.',
  'blocks.hint.itemTitle': '{title} diganti dengan nama item.',
  'blocks.hint.productCount': '{count} diganti dengan jumlah produk.',
  'blocks.hint.count': '{count} diganti dengan angkanya.',
  'blocks.note.catalogue': 'Item berasal dari konten katalog yang sudah terbit dan mengikuti urutannya.',
  'blocks.note.swatches': 'Item berasal dari Bahan & Finishing. Sampel ditempatkan di bawah grup yang kuncinya cocok dengan “Kunci grup”-nya; sampel tanpa grup yang cocok tidak ditampilkan.',
  'blocks.f.label': 'Label',
  'blocks.f.link': 'Tautan',
  'blocks.f.linkOptional': 'Tautan (opsional)',
  'blocks.f.eyebrow': 'Teks atas',
  'blocks.f.heading': 'Judul',
  'blocks.f.headline': 'Judul utama',
  'blocks.f.body': 'Isi',
  'blocks.f.content': 'Konten',
  'blocks.f.intro': 'Pengantar',
  'blocks.f.image': 'Gambar',
  'blocks.f.backgroundImage': 'Gambar latar',
  'blocks.f.photo': 'Foto',
  'blocks.f.photos': 'Foto',
  'blocks.f.background': 'Latar belakang',
  'blocks.f.layout': 'Tata letak',
  'blocks.f.style': 'Gaya',
  'blocks.f.columns': 'Kolom',
  'blocks.f.value': 'Nilai',
  'blocks.f.title': 'Judul',
  'blocks.f.key': 'Kunci',
  'blocks.f.name': 'Nama',
  'blocks.f.role': 'Jabatan',
  'blocks.f.badge': 'Lencana',
  'blocks.f.bio': 'Bio',
  'blocks.f.tagline': 'Tagline',
  'blocks.f.caption': 'Keterangan',
  'blocks.f.quote': 'Kutipan',
  'blocks.f.nameOrRole': 'Nama atau jabatan',
  'blocks.f.organisation': 'Organisasi',
  'blocks.f.answer': 'Jawaban',
  'blocks.f.anchor': 'Anchor',
  'blocks.f.youtube': 'Video YouTube',
  'blocks.f.imageSide': 'Sisi gambar',
  'blocks.f.imageStyle': 'Gaya gambar',
  'blocks.f.statsUnderText': 'Statistik di bawah teks (opsional)',
  'blocks.f.sideImage': 'Gambar samping (opsional)',
  'blocks.f.cardLinkText': 'Teks tautan kartu',
  'blocks.f.listHeading': 'Judul daftar',
  'blocks.f.exclusionsHeading': 'Judul pengecualian',
  'blocks.f.numberCards': 'Beri nomor pada kartu (01, 02, …)',
  'blocks.f.headerLinkLabel': 'Label tautan header',
  'blocks.f.headerLink': 'Tautan header',
  'blocks.f.labelAboveTitle': 'Label (di atas judul)',
  'blocks.f.issuerUnderTitle': 'Penerbit (di bawah judul)',
  'blocks.f.list': 'Daftar',
  'blocks.f.notIncluded': 'Tidak termasuk',
  'blocks.f.legalTitle': 'Judul dokumen (H1)',
  'blocks.f.primaryLabel': 'Label utama',
  'blocks.f.secondaryLabel': 'Label sekunder',
  'blocks.f.buttons': 'Tombol',
  'blocks.f.lists': 'Menampilkan',
  'blocks.f.itemLinkText': 'Teks tautan item',
  'blocks.f.productCount': 'Jumlah produk',
  'blocks.f.extraGroupHeading': 'Judul grup tambahan',
  'blocks.f.allTabLabel': 'Label tab “Semua”',
  'blocks.f.countLabel': 'Label jumlah',
  'blocks.f.filterTabs': 'Tab filter',
  'blocks.f.tabLabel': 'Label tab',
  'blocks.f.project': 'Proyek',
  'blocks.f.client': 'Klien',
  'blocks.f.finishes': 'Finishing',
  'blocks.f.filter': 'Filter',
  'blocks.f.wide': 'Lebar',
  'blocks.f.groupN': 'Label grup {n}',
  'blocks.f.sideEyebrow': 'Teks atas samping',
  'blocks.f.sideTitle': 'Judul samping',
  'blocks.f.numberedPoints': 'Poin bernomor',
  'blocks.f.figures': 'Angka (baris label dan nilai)',
  'blocks.f.linkLabel': 'Label tautan',
  'blocks.f.buttonLabel': 'Label tombol',
  'blocks.f.buttonLink': 'Tautan tombol',
  'blocks.f.responsibilities': 'Tanggung jawab',
  'blocks.f.clientLabel': 'Label (klien)',
  'blocks.f.clientQuote': 'Kutipan klien',
  'blocks.f.tags': 'Tag',
  'blocks.f.credit': 'Baris kredit',
  'blocks.f.stripImage': 'Gambar (ditampilkan sebagai pita selebar penuh setinggi 120px)',
  'blocks.f.shows': 'Menampilkan',
  'blocks.f.jumpLinks': 'Baris tautan lompat beserta jumlah di atas grup',
  'blocks.f.groupsInOrder': 'Grup, sesuai urutan',
  'blocks.f.titledAnswers': 'Jawaban berjudul',
  'blocks.add.link': '+ Tautan',
  'blocks.add.button': '+ Tombol',
  'blocks.add.stat': '+ Statistik',
  'blocks.add.card': '+ Kartu',
  'blocks.add.quote': '+ Kutipan',
  'blocks.add.image': '+ Gambar',
  'blocks.add.headerLink': '+ Tautan header',
  'blocks.add.filter': '+ Filter',
  'blocks.add.project': '+ Proyek',
  'blocks.add.item': '+ Item',
  'blocks.add.exclusion': '+ Pengecualian',
  'blocks.add.row': '+ Baris',
  'blocks.add.point': '+ Poin',
  'blocks.add.person': '+ Orang',
  'blocks.add.role': '+ Jabatan',
  'blocks.add.group': '+ Grup',
  'blocks.add.tag': '+ Tag',
  'blocks.add.answer': '+ Jawaban',
  'blocks.remove': 'Hapus',
  'blocks.removeGroup': 'Hapus grup',
  'blocks.removePerson': 'Hapus orang',
  'blocks.ph.exploreSector': 'Jelajahi sektor',
  'blocks.ph.youReceive': 'Yang Anda terima',
  'blocks.ph.exploreTitle': 'Jelajahi {title}',
  'blocks.ph.countTypes': '{count} jenis',
  'blocks.ph.specification': 'Spesifikasi',
  'blocks.ph.countWorks': '{count} karya',
  'blocks.ph.officeBadge': 'Kantor Australia',
  'blocks.ph.designBy': 'Desain oleh …',
  'blocks.opt.ivory': 'Gading',
  'blocks.opt.linen': 'Linen',
  'blocks.opt.bone': 'Putih tulang',
  'blocks.opt.ink': 'Tinta (gelap)',
  'blocks.opt.right': 'Kanan',
  'blocks.opt.left': 'Kiri',
  'blocks.opt.materials': 'Bahan',
  'blocks.opt.edgeToEdge': 'Tepi ke tepi',
  'blocks.opt.insetCard': 'Kartu menjorok (sudut bulat, bayangan)',
  'blocks.opt.hero.fullBleed': 'Gambar selebar penuh',
  'blocks.opt.hero.split': 'Teks di samping gambar bersudut bulat',
  'blocks.opt.hero.text': 'Pengantar halaman ringkas',
  'blocks.opt.hero.statement': 'Pengantar pernyataan besar',
  'blocks.opt.hero.video': 'Teks di samping video YouTube',
  'blocks.opt.hero.centered': 'Pengantar kecil di tengah',
  'blocks.opt.grid.grid': 'Grid kartu gambar',
  'blocks.opt.grid.carousel': 'Carousel (digeser ke samping)',
  'blocks.opt.grid.bordered': 'Sel bergaris dengan tautan',
  'blocks.opt.grid.aside': 'Pengantar + gambar di samping kartu teks',
  'blocks.opt.grid.numbered': 'Kartu foto bernomor',
  'blocks.opt.grid.certificates': 'Dokumen berbingkai (sertifikat)',
  'blocks.opt.grid.facts': 'Fakta (label, judul, teks)',
  'blocks.opt.grid.gallery': 'Foto dalam bingkai dengan judul',
  'blocks.opt.grid.levels': 'Kolom bergaris dengan daftar',
  'blocks.opt.grid.definitions': 'Grid istilah / definisi',
  'blocks.opt.content.prose': 'Artikel panjang editorial',
  'blocks.opt.content.legal': 'Dokumen hukum (teks polos, H1 sendiri)',
  'blocks.opt.faq.list': 'Satu kolom',
  'blocks.opt.faq.columns': 'Dua kolom pada pita berwarna',
  'blocks.opt.imageGrid.tiles': 'Petak foto persegi',
  'blocks.opt.imageGrid.logos': 'Strip logo',
  'blocks.opt.catalogue.industries': 'Industri (sel tautan)',
  'blocks.opt.catalogue.families': 'Kategori produk (kartu)',
  'blocks.opt.catalogue.index': 'Semua produk, per kategori',
  'blocks.opt.cta.centered': 'Bagian di tengah',
  'blocks.opt.cta.band': 'Pita satu baris',
  'blocks.opt.cta.left': 'Bagian gelap rata kiri',
  'blocks.opt.columns.ruled': 'Baris bergaris (judul di kiri, teks di kanan)',
  'blocks.opt.columns.callout': 'Callout (pembagian 7/5 di bawah garis)',
  'blocks.opt.columns.centered': 'Judul di tengah, teks sempit',
  'blocks.meta.game.label': 'Game',
  'blocks.meta.game.description': 'Panel game dengan ponsel, tombol toko, dan tangkapan layar',
  'blocks.f.gameTag': 'Label',
  'blocks.ph.gameTag': 'Segera hadir',
  'blocks.f.gameTitle': 'Nama game',
  'blocks.f.phoneImage': 'Game di layar ponsel (mendatar)',
  'blocks.f.mascot': 'Karakter (opsional, PNG atau WebP tanpa latar)',
  'blocks.f.googlePlay': 'Google Play',
  'blocks.f.appStore': 'App Store',
  'blocks.f.storeUrl': 'Tautan toko',
  'blocks.hint.googlePlay': 'Tautan https://play.google.com/…',
  'blocks.hint.appStore': 'Tautan https://apps.apple.com/…',
  'blocks.err.googlePlay': 'Pakai tautan https://play.google.com/…',
  'blocks.err.appStore': 'Pakai tautan https://apps.apple.com/…',
  'blocks.opt.store.off': 'Tidak ditampilkan',
  'blocks.opt.store.soon': 'Segera hadir (tanpa tautan)',
  'blocks.opt.store.live': 'Sudah rilis: tautan ke toko',
  'blocks.f.gameButton': 'Tombol (opsional)',
  'blocks.f.gameMore': 'Tombol "Selengkapnya" (opsional)',
  'blocks.hint.gameMore': 'Halaman atau situs game-nya sendiri. Nama game dan gambar ponselnya juga mengarah ke sana.',
  'blocks.f.screenshots': 'Tangkapan layar (maks. 4, mendatar)',
  'blocks.add.screenshot': '+ Tangkapan layar',
  'blocks.opt.cta.form': 'Teks di samping formulir kontak',
}
